import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { IRootState } from "../../../../../reducer/CombineReducer";
import { ButtonVariantType } from "../../../../Common/UI/Types";
import { Button, Dropdown } from "../../../../Common/UI/Index";
import { FilterBoxType } from "./Types";
import "../FinalOutputList/Styles.scss";

interface Props {
  /**
   * Healthcheck action
   */
  onRunHealthCheck: () => void;
  /**
   * Dropdown data
   */
  data: FilterBoxType[];
  /**
   * Set Filterby value 
   */
  onFilterBy: (value: string) => void;
}

export const FinalOutputButtonsBarView: React.FC<Props> = (props: Props) => {
  const { onRunHealthCheck, data, onFilterBy } = props;
  const outputConfig = useSelector((state: IRootState) => state.outputConfig);
  const { finalOutputFilterBy } = outputConfig;
  const { t: translate } = useTranslation();

  /**
   * Set default filter by value
   */
  useEffect(() => {
    onFilterBy(data && data[0] && data[0].value);
  }, []);

  return (
    <div
      className="ebt-final-output"
      id="ebt-outputConfig-finalOutput"
    >
      <div>
        <Button
          variant={ButtonVariantType.FILLED}
          onClick={onRunHealthCheck}
          id="ebt-outputConfig-finalOutput-run-btn"
        >
          {translate("OutputConfig.FinalButtons.RunHealthCheck")}
        </Button>
      </div>
      <div className="ebt-final-filter">
        <div
          className="ebt-filter-text"
          id="ebt-outputConfig-finalOutput-filterBy"
        >
          {translate("OutputConfig.FinalOutputTable.FilterBy")}
        </div>
        <div
          className="ebt-final-dropdown"
          id="ebt-outputConfig-finalOutput-status"
        >
          <Dropdown
            ariaLabel="interactive"
            dataSource={data}
            value={finalOutputFilterBy}
            onChange={onFilterBy}
          />
        </div>
      </div>
    </div>
  );
};
